module.exports = __webpack_public_path__ + "img/B.1d7ed361.png";